import React, { useContext, useEffect, useState } from "react";
import { ref, set, push, onValue, get } from "firebase/database";
import {
  Typography,
  List,
  ListItem,
  IconButton,
  ListItemText
} from '@mui/material';
import {
  CompareSharp,
  SettingsBackupRestore as SettingsBackupRestoreIcon
} from '@mui/icons-material';
import { AuthContext, restore_items } from "components/Auth";
import { Layout as DashboardLayout } from 'layouts/portal/layout';

const timestamp_sort = (a, b) => {

}

export const RestoreProducts = () => {
  const [ deletions, setDeletions ] = useState([]);
  const { selectedStore, notify, database } = useContext(AuthContext);

  useEffect(() => {
    const deletions_ref = ref(database, `deletions/${selectedStore}`);
    
    return onValue(deletions_ref, (snapshot) => {
      const data = snapshot.val() || [];
      console.log('deletions', data)
      setDeletions(data);
    });
  }, [selectedStore])

  const handleClick = (deletion_id) => {
    restore_items({
      store: selectedStore,
      deletion: deletion_id
    }).then((res) => {
      if (res?.data?.status === 'success') {
        notify({ message: `Items have been restored to ${deletions?.[deletion_id]?.title}` });  
      } else {
        notify({ message: `There was an error trying to restore products. Please try again or contact us at support@thefavesapp.com`, variant: 'error' });  
      }
    }).catch((err) => {
      notify({ message: `There was an error trying to restore products. Please try again or contact us at support@thefavesapp.com`, variant: 'error' });
    })
  }

  return (
    <DashboardLayout>
      <Typography variant="h2">Recently Deleted</Typography>
      <Typography mb={5} variant="body">
        Restored products will appear in the collection "RESTORED PRODUCTS" in the original season.
      </Typography>

      {Object.keys(deletions).length === 0 && (
        <Typography variant="subtitle1">You have no recently deleted items</Typography>
      )} 

      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
        {Object.keys(deletions).sort((b, a) => deletions[a]?.timestamp - deletions[b]?.timestamp).map((deletion_id) => {
          // Generate 'nice' date
          const d = new Date(deletions?.[deletion_id]?.timestamp * 1000);
          d.setHours(0, 0, 0, 0);

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          let formattedDate;

          if (d.getTime() === today.getTime()) {
            formattedDate = "Today";
          } else if (d.getTime() === today.getTime() - (1000 * 60 * 60 * 24)) {
            formattedDate = "Yesterday";
          } else {
            const options = { day: '2-digit', month: 'long', year: 'numeric' };
            formattedDate = d.toLocaleDateString('en-GB', options);
          }

          return <ListItem
            key={deletion_id}
            disableGutters
            secondaryAction={
              <IconButton onClick={() => { handleClick(deletion_id) }} aria-label="comment">
                <SettingsBackupRestoreIcon />
              </IconButton>
            }
          >
            <ListItemText 
              primary={formattedDate}
              secondary={`${deletions?.[deletion_id]?.numItems} product${deletions?.[deletion_id]?.numItems > 1 ? 's' : ''} ${deletions?.[deletion_id]?.title}`}
            />
          </ListItem>
        })}
      </List>
    </DashboardLayout>
  );
};
